// Owner - SignUp
export const SIGN_UP_OWNER_REQUEST = "SIGN_UP_OWNER_REQUEST";
export const SIGN_UP_OWNER_SUCCESS = "SIGN_UP_OWNER_SUCCESS";
export const SIGN_UP_OWNER_ERROR = "SIGN_UP_OWNER_ERROR";

// Owner - SignIn
export const SIGN_IN_REQUEST = "SIGN_IN_REQUEST";
export const SIGN_IN_OWNER_SUCCESS = "SIGN_IN_OWNER_SUCCESS";
export const SIGN_IN_OWNER_ERROR = "SIGN_IN_OWNER_ERROR";

// SignOut
export const SIGN_OUT_REQUEST = "SIGN_OUT_REQUEST";

// Mutations
export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";

export const SIGN_OUT_SUCCESS = "SIGN_OUT_SUCCESS";

export const HOME_ROUTE_UPDATE = "HOME_ROUTE_UPDATE";
